import { h } from 'hyperapp'

export default (children) => h(
    'div',
{
    class: 'header',
},
    children
)